// Підготовка вкладень тікету (логи та інші матеріали) до архівування.

// Прибирає з імені файлу символи, неприпустимі для шляху всередині архіву
function sanitizeFilename(name){
    return String(name || "file").replace(/[\\/:*?"<>|]+/g, "_").trim() || "file";
}

// zip-архіви у тікетах - це логи; визначаємо за mime-типом або розширенням
function isLogArchive(file){
    return (file.type || "").includes("zip") || /\.zip$/i.test(file.name || "");
}

// Нормалізує вкладення для архіву:
// - нумерує в порядку додавання (NN_<ім'я файлу>)
// - позначає zip-архіви як логи
// attachments: [{ name, type, datetime, data (ArrayBuffer/Blob) }]
function prepareAttachments(attachments){
    let files = Array.isArray(attachments) ? attachments : [];
    return files.map((file, i) => {
        let order = String(i + 1).padStart(2, "0");
        return {
            ...file,
            archivedName: `${order}_${sanitizeFilename(file.name)}`,
            isLog: isLogArchive(file)
        };
    });
}

export { prepareAttachments };
